import { useMutation } from '@tanstack/react-query';
import { Alert, Button, Drawer, Form, Input, message, Select, Space } from 'antd';
import saveAs from 'file-saver';
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiError, AssetProjectEditDTO, AssetProjectViewDTO } from '../../backendapi/requests';
import { useAssetProjectServicePostBackendv2Assetproject } from '../../backendapi/queries';
import { ConfigContext } from '../../contexts/ConfigContext';
import { BASE_PATH } from '../../Environment';



const CreateAssetProject: React.FC<{ isOpen: boolean, onClose: () => void }> = ({ isOpen, onClose }) => {

    const { currentClient } = useContext(ConfigContext)

    const [form] = Form.useForm<AssetProjectEditDTO>();
    const [file, setFile] = useState<File | undefined>(undefined);
    const navigate = useNavigate();

    const { mutateAsync: createAssetProject, isPending, isSuccess, error, data } = useAssetProjectServicePostBackendv2Assetproject<AssetProjectViewDTO, ApiError, AssetProjectEditDTO>()

   /* const {mutate, isPending, isSuccess, error, data} = useMutation<AssetProjectViewDTO, ApiError, AssetProjectEditDTO>({ mutationFn: (form: AssetProjectEditDTO) => request(OpenAPI, {
        method: 'POST',
        url: '/AssetProject',
        formData: form
    })});*/

    const downloadTemplate = useCallback(() => {
        const token = localStorage.getItem('accessToken');

        fetch(`${BASE_PATH}/backendv2/assetproject/0/excelTemplate?clientId=${currentClient.id}`, {
            method: 'get',
            headers: {
                "Authorization": 'Bearer ' + token
            }
        }).then(response => {
            return response.blob();
        }).then(blob => {
            saveAs(blob, "assets.xlsx");
        });
    }, [currentClient]);

    const onSubmit = () => {
        form.submit();
    };

    const onFinish = async () => {
        const values = form.getFieldsValue(true) as AssetProjectEditDTO;
        values.clientId = currentClient.id;
        await createAssetProject({ formData: values });
    };

    useEffect(() => {
        if (isSuccess && data) {
            message.success("Project created");
            navigate("/assetprojects/" + data.id)
        }
    }, [data, isSuccess, navigate]);

    const onFileChanged = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.currentTarget.files;

        if (files && files.length !== 0) {
            setFile(files[0]);
        } else {
            setFile(undefined);
        }
    }, []);

    const errors: string[] | undefined = useMemo(() => {

        if(error){
            if(error.body && Array.isArray(error.body)){
                let errorMessages = error.body;
                return errorMessages.map(e => `line: ${e.line} -> ${e.message}`);
            }else{
                return [error.message];
            }
        }

        return undefined;
    }, [error]);

    return (
        <>
            <Drawer
                title="Create a new project"
                size={720}
                onClose={onClose}
                open={isOpen}
                extra={
                    <Space>
                        <Button onClick={onClose}>Cancel</Button>
                        <Button onClick={onSubmit} type="primary" loading={isPending}>
                            Submit
                        </Button>
                    </Space>
                }
            >
                <Form
                    name="basic"
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}>
{/* 
                    <Form.Item rules={[{ required: true }]} name='clientId' label="Client">
                        <Select options={clients?.value.map(e => ({ label: e.name, value: e.id }))} />
                    </Form.Item> */}

                    <Form.Item rules={[{ required: true }]} name='title' label="Title">
                        <Input />
                    </Form.Item>

                    <Form.Item name='assets' label={<>Assets <Button type='link' onClick={downloadTemplate}>download template</Button></>} >
                        <input type='file' accept='.xlsx' onChange={onFileChanged} />
                    </Form.Item>
                </Form>

                {errors && <Alert
                    message="Error"
                    description={errors?.map(e => <p>{e}</p>)}
                    type="error"
                    showIcon
                    />}
                
                
            </Drawer>
        </>

    );
};

export default CreateAssetProject;